// Order for the Stop workout dialog's buttons: the usual choice first, the
// safe way back second, and the destructive one last.
const rank = (action) => {
  const label = String(action?.label || "").toLowerCase();
  if (label.includes("save")) return 0;
  if (action?.cancel) return 1;
  if (label.includes("discard")) return 3;
  return 2;
};

export const orderStopActions = (actions = []) =>
  actions
    .map((action, i) => ({ action, i }))
    .sort((a, b) => rank(a.action) - rank(b.action) || a.i - b.i)
    .map(({ action }) => action);
